
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehiclefleetapp/not-found",
      function () {
        return require("private-next-pages/vehiclefleetapp/not-found.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehiclefleetapp/not-found"])
      });
    }
  